import React, { useState, useEffect, useCallback } from 'react';
import { db } from './firebase';
import { ref, onValue, set} from 'firebase/database';
import '../App.css';

const teams = {
  teams_logos: [
    { name: "Wolf Musta U9", logoUrl: "https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png" },
    { name: "Wolf Musta", logoUrl: "https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png" },
    { name: "Wolf Keltainen U9", logoUrl: "https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png" },
    { name: "Wolf Keltainen", logoUrl: "https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png" },
    { name: "Hunters White U9", logoUrl: "https://static.jopox.fi/hunters/logos/logo-600.png" },
    { name: "Hunters Blue U9", logoUrl: "https://static.jopox.fi/hunters/logos/logo-600.png" },
    { name: "Hunters U8", logoUrl: "https://static.jopox.fi/hunters/logos/logo-600.png" },
    { name: "K-Espoo Blue", logoUrl: "https://upload.wikimedia.org/wikipedia/en/thumb/2/23/Kiekko-Espoo_logo_2021.png/250px-Kiekko-Espoo_logo_2021.png" },
    { name: "K-Espoo Yellow", logoUrl: "https://upload.wikimedia.org/wikipedia/en/thumb/2/23/Kiekko-Espoo_logo_2021.png/250px-Kiekko-Espoo_logo_2021.png" },
    { name: "K-Espoo White", logoUrl: "https://upload.wikimedia.org/wikipedia/en/thumb/2/23/Kiekko-Espoo_logo_2021.png/250px-Kiekko-Espoo_logo_2021.png" },
    { name: "K-Kissat Cats", logoUrl: "https://upload.wikimedia.org/wikipedia/fi/3/3f/Karhu-Kissat.png?20161030101639" },
    { name: "K-Kissat Bears", logoUrl: "https://upload.wikimedia.org/wikipedia/fi/3/3f/Karhu-Kissat.png?20161030101639" },
    { name: "Viikingit White U9", logoUrl: "https://upload.wikimedia.org/wikipedia/fi/e/e3/Viikingit_HC_logo.png"},
    { name: "Viikingit Red U9", logoUrl: "https://upload.wikimedia.org/wikipedia/fi/e/e3/Viikingit_HC_logo.png"},

  ]
};


const SunnuntaiU8 = ({ isAdmin }) => {

  const teams_name = {
    U8_lohko_A: [
      
      { name: "K-Espoo Blue", logoUrl: "https://upload.wikimedia.org/wikipedia/en/thumb/2/23/Kiekko-Espoo_logo_2021.png/250px-Kiekko-Espoo_logo_2021.png" },
      { name: "K-Kissat Cats", logoUrl: "https://upload.wikimedia.org/wikipedia/fi/3/3f/Karhu-Kissat.png?20161030101639" },
      { name: "Wolf Musta", logoUrl: "https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png" },
      { name: "K-Espoo Yellow", logoUrl: "https://upload.wikimedia.org/wikipedia/en/thumb/2/23/Kiekko-Espoo_logo_2021.png/250px-Kiekko-Espoo_logo_2021.png" },
      
     
    ],
    U8_lohko_B: [
      { name: "K-Kissat Bears", logoUrl: "https://upload.wikimedia.org/wikipedia/fi/3/3f/Karhu-Kissat.png?20161030101639" },
      { name: "Hunters U8", logoUrl: "https://static.jopox.fi/hunters/logos/logo-600.png" },
      { name: "K-Espoo White", logoUrl: "https://upload.wikimedia.org/wikipedia/en/thumb/2/23/Kiekko-Espoo_logo_2021.png/250px-Kiekko-Espoo_logo_2021.png" },
    
      { name: "Wolf Keltainen", logoUrl: "https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png" },
    ],
  };


  const defaultGames = {
    U8_lohko_A: [ 
    { id: 1, time: '11:45', team1: 'Wolf Musta', team2: 'K-Espoo Blue', result1: '', result2: '',status:'' },    
    { id: 2, time: '12:30', team1: 'K-Kissat Cats', team2: 'K-Espoo Yellow', result1: '', result2: '',status:'' },
    { id: 3, time: '13:30', team1: 'Wolf Musta', team2: 'K-Espoo Yellow', result1: '', result2: '',status:'' },
    { id: 4, time: '15:50', team1: 'K-Kissat Cats', team2: 'K-Espoo Blue', result1: '', result2: '',status:'' },
    { id: 5, time: '16:20', team1: 'Wolf Musta', team2: 'K-Kissat Cats', result1: '', result2: '',status:'' },
    { id: 6, time: '16:50', team1: 'K-Espoo Blue', team2: 'K-Espoo Yellow', result1: '', result2: '',status:'' },
    ],
    U8_lohko_B:[
      { id: 1, time: '11:45', team1: 'Wolf Keltainen', team2: 'K-Espoo White', result1: '', result2: '',status:'' },
      { id: 2, time: '12:30', team1: 'K-Kissat Bears', team2: 'Hunters U8', result1: '', result2: '',status:'' },
      { id: 3, time: '13:30', team1: 'Wolf Keltainen', team2: 'Hunters U8', result1: '', result2: '',status:'' },
      { id: 4, time: '15:50', team1: 'K-Kissat Bears', team2: 'K-Espoo White', result1: '', result2: '',status:'' },
      { id: 5, time: '16:20', team1: 'K-Espoo White', team2: 'Hunters U8', result1: '', result2: '',status:'' },
      { id: 6, time: '16:50', team1: 'Wolf Keltainen', team2: 'K-Kissat Bears', result1: '', result2: '',status:'' },

    ],
    U8_sijoitusottelut:[
      { id: 1, time: '17:35', team1: 'K-Kissat Cats', team2: 'K-Kissat Bears', result1: '4', result2: '1',rankingMatch :"Sijat 7 & 8"},
      { id: 2, time: '17:35', team1: 'K-Espoo Blue', team2: 'Hunters U8', result1: '6', result2: '5',rankingMatch :"Sijat 5 & 6" },
      { id: 3, time: '18:10', team1: 'K-Espoo Yellow', team2: 'Wolf Keltainen', result1: '5', result2: '6',rankingMatch :"Sijat 3 & 4" },
      { id: 4, time: '18:10', team1: 'Wolf Musta', team2: 'K-Espoo White', result1: '4', result2: '5',rankingMatch :"Sijat 1 & 2" },
      
    ],
  }
 
  const [games, setGames] = useState(defaultGames);
  const [activeTab, setActiveTab] = useState("A");
  const [selectedSubTab, setSelectedSubTab] = useState('games');
  const lohko =
    activeTab === 'A'
      ? 'U8_lohko_A'
      : activeTab === 'B'
      ? 'U8_lohko_B'
      : 'U8_sijoitusottelut';
      useEffect(() => {
        const fetchGameData = async () => {
          const dbRef = ref(db, "games/sunnuntai/U8");
          onValue(dbRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
              setGames((prevGames) => ({
                ...prevGames,
                ...data,
              }));
            }
          });
        };
        fetchGameData();
      }, []);
      
  // Function to handle score change
  const handleResultChange = (lohko, gameId, resultField, newValue) => {
    setGames((prevGames) => {
      const updatedGames = { ...prevGames };
      const gameIndex = updatedGames[lohko].findIndex((game) => game.id === gameId);
      if (gameIndex !== -1) {
        updatedGames[lohko][gameIndex] = {
          ...updatedGames[lohko][gameIndex],
          [resultField]: newValue,
        };
      }
      return updatedGames;
    });
  };


  // Save the updated game data back to Firebase
  const handleSave = () => {
    const dbRef = ref(db, `games/sunnuntai/U8/${lohko}`);
    set(dbRef, games[lohko])
      .then(() => {
        alert("Games saved successfully!");
      })
      .catch((error) => {
        console.error("Error saving data: ", error);
        alert("Failed to save games.");
      });
  };


  // Calculate the standings based on game results
  const calculateTeamStats = useCallback(
    (lohko) => {
      const groupGames = games[lohko];
      const teamStats = {};

      groupGames.forEach((game) => {
        const { team1, team2 } = game;
        if (!teamStats[team1]) {
          teamStats[team1] = { name: team1, win: 0, loss: 0, draw: 0, points: 0, goalsFor: 0, goalsAgainst: 0, gamesPlayed: 0 };
        }
        if (!teamStats[team2]) {
          teamStats[team2] = { name: team2, win: 0, loss: 0, draw: 0, points: 0, goalsFor: 0, goalsAgainst: 0, gamesPlayed: 0 };
        }

        const result1 = parseInt(game.result1);
        const result2 = parseInt(game.result2);

        if (!isNaN(result1) && !isNaN(result2)) {
          teamStats[team1].goalsFor += result1;
          teamStats[team1].goalsAgainst += result2;
          teamStats[team2].goalsFor += result2;
          teamStats[team2].goalsAgainst += result1;

          if (result1 > result2) {
            teamStats[team1].win++;
            teamStats[team1].points += 2;
            teamStats[team2].loss++;
          } else if (result1 < result2) {
            teamStats[team2].win++;
            teamStats[team2].points += 2;
            teamStats[team1].loss++;
          } else {
            teamStats[team1].draw++;
            teamStats[team2].draw++;
            teamStats[team1].points += 1;
            teamStats[team2].points += 1;
          }

          teamStats[team1].gamesPlayed++;
          teamStats[team2].gamesPlayed++;
        }
      });

      return Object.values(teamStats).sort((a, b) => {
        if (b.points !== a.points) return b.points - a.points;
        const goalDiffA = a.goalsFor - a.goalsAgainst;
        const goalDiffB = b.goalsFor - b.goalsAgainst;
        if (goalDiffB !== goalDiffA) return goalDiffB - goalDiffA;
        return b.goalsFor - a.goalsFor;
      });
    },
    [games]
  );

  
  const generateSijoitusottelut = useCallback(() => {
    const u8_lohko_A = calculateTeamStats("U8_lohko_A");
    const u8_lohko_B = calculateTeamStats("U8_lohko_B");

    const allTeamsPlayed = (teams) => teams.every((team) => team.gamesPlayed === 3);

    if (allTeamsPlayed(u8_lohko_A) && allTeamsPlayed(u8_lohko_B)) {
      const timesU8 = ["17:35", "17:35", "18:10", "18:10"];
      const rankingMatch = ["Sijat 7-8", "Sijat 5-6", "Sijat 3-4", "Sijat 1-2"];

      return {
        U8_sijoitusottelut: u8_lohko_A.map((_, index) => ({
          id: index + 1,
          time: timesU8[index],
          team1: u8_lohko_A[3 - index].name,
          team2: u8_lohko_B[3 - index].name,
          rankingMatchU8: rankingMatch[index],
        })),
      };
    }

    return { U8_sijoitusottelut: [] };
  }, [calculateTeamStats]);

  const sijoitusottelut = generateSijoitusottelut();


    return (
      <div className="game-container">
        <h4 className="date-title">Sunnuntai 18.05.2025</h4>
        <hr/>
        <h2>U8 otteluohjelma</h2>
    
        {/* Main tabs */}
        <div className="three-tab-layout">
          <div className="tab-container">
            <div
              className="highlight-slider"
              style={{
                transform:
                  activeTab === 'A' ? 'translateX(0%)'
                  : activeTab === 'B' ? 'translateX(100%)'
                  : 'translateX(200%)'
              }}
            />
            {['A','B','sijoitusottelut'].map(key => (
              <button
                key={key}
                className={`U8-lohko-tab-button ${activeTab===key?'active':''}`}
                onClick={() => setActiveTab(key)}
              >
                { key==='A' ? 'Lohko A' : key==='B' ? 'Lohko B' : 'Sijoitusottelut' }
              </button>
            ))}
          </div>
        </div>
    
        {/* Team list for A/B */}
        {lohko !== 'U8_sijoitusottelut' && (
          <div>
            <h2 className="team-list-title">Joukkueet | Lohko {lohko.slice(-1)}</h2>
            <div className="team-list">
              {teams_name[lohko].length
                ? <div className="team-container">
                    {teams_name[lohko].map((team,i) => (
                      <div key={i} className="team-item">
                        <img src={team.logoUrl} alt={team.name} className="team-logo"/>
                        <span className="teamlist-name">{team.name}</span>
                      </div>
                    ))}
                  </div>
                : <p>No teams available</p>
              }
            </div>
          </div>
        )}
    
         {lohko === "U8_sijoitusottelut" && (
        <div>
          <h2>Sijoituspelit</h2>
        {games.U8_sijoitusottelut.length > 0 ? (
      games.U8_sijoitusottelut.map((game) => (
        <div className="game-info" key={game.id}>
        <div className="game-name">{game.rankingMatch}</div>
        <div className="game-info-header">
          <div className="game-row">Klo {game.time}</div>
          <div className="game-row">
            {lohko === "U8_lohko_A" && "(Lehvosen pääty)"}
            {lohko === "U8_lohko_B" && "(Kellopääty)"}
            <span>
              {lohko === "U8_sijoitusottelut" &&
                (game.id % 2 === 0 ? "(Kellopääty)" : "(Lehvosen Pääty)")}
            </span>
          </div>
        </div>
        <div className="game-row">
          <table className="game-table">
            <tbody>
              <tr>
               <td className="team-name">{game.team1}</td>
                <td className="game-result">
                  <span className="game-result-text">{game.result1 || "0"}</span>
                </td>
                <td className="separator">-</td>
                <td className="game-result">
                  <span className="game-result-text">{game.result2 || "0"}</span>
                </td>
                 <td className="team-name">{game.team2}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      ))
    ) : (
      <p>No sijoitusottelut games found</p>
    )}
        </div>
        
      )}
    
        {/* Sub-tabs for A/B only */}
        {lohko !== 'U8_sijoitusottelut' && (
          <div className="tab-container">
            <div
              className="highlight-slider"
              style={{
                transform: selectedSubTab==='games'
                  ? 'translateX(0%)'
                  : 'translateX(100%)'
              }}
            />
            <button
              className={`lohko-tab-button ${selectedSubTab==='games'?'active':''}`}
              onClick={()=>setSelectedSubTab('games')}
            >Ottelut</button>
            <button
              className={`lohko-tab-button ${selectedSubTab==='lohkotilanne'?'active':''}`}
              onClick={()=>setSelectedSubTab('lohkotilanne')}
            >Lohkotilanne</button>
          </div>
        )}
    
        {/* === Sub-tab: Ottelut for A/B === */}
        {selectedSubTab==='games' && lohko!=='U8_sijoitusottelut' && (
          <div>
           <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <h2>Ottelut | Lohko {lohko.slice(-1)}</h2>
            </div>
            {games[lohko].map(game => (
  <div key={game.id} className="game-info">
    <div className="game-info-header">
      <div className="game-row">Klo {game.time}</div>
      <div className="game-row">
        {lohko === 'U8_lohko_A' && '(Lehvosen pääty)'}
        {lohko === 'U8_lohko_B' && '(Kellopääty)'}
      </div>
      
    </div>
    <div className="game-row">
       {/* Save button specific to this game */}
    {isAdmin && (
      <div className="save-button-container">
        <button onClick={() => handleSave(game.id)} className="save-button">Tallenna</button>
      </div>
    )}
      </div>
      
    <div className="game-row">
      <table className="game-table">
        <tbody>
          <tr>
            <td className="team-logo-cell">
              <img
                src={teams.teams_logos.find((team) => team.name === game.team1)?.logoUrl || "default-logo.png"}
                alt={game.team1}
                className="team-logo"
              />
            </td>
            <td className='game-result'>
              {isAdmin ? (
                <input
                  type="text"
                  value={game.result1}
                  onChange={(e) => handleResultChange(lohko, game.id, 'result1', e.target.value)}
                  placeholder="0"
                  className="game-result-input"
                />
              ) : (
                <span className="game-result-text">{game.result1 || '0'}</span>
              )}
            </td>
            <td className="separator">-</td>
            <td className='game-result'>
              {isAdmin ? (
                <input
                  type="text"
                  value={game.result2}
                  onChange={(e) => handleResultChange(lohko, game.id, 'result2', e.target.value)}
                  placeholder="0"
                  className="game-result-input"
                />
              ) : (
                <span className="game-result-text">{game.result2 || '0'}</span>
              )}
            </td>
            <td className="team-logo-cell">
              <img
                src={teams.teams_logos.find((team) => team.name === game.team2)?.logoUrl || "default-logo.png"}
                alt={game.team2}
                className="team-logo"
              />
            </td>
          </tr>
          <tr>
            <td className="team-name">{game.team1}</td>
            <td colSpan="3"></td>
            <td className="team-name">{game.team2}</td>
          </tr>
        </tbody>
      </table>
    </div>

    
  </div>
))}
          </div>
        )}
    
        {/* === Sub-tab: Ottelut for Sijoitusottelut === */}
        {lohko==='U8_sijoitusottelut' && (
          sijoitusottelut[lohko].length===0
          ? (
            /* Basic text table */
            <div>
              {games[lohko].map(game => (
                 <div className="game-info" key={game.id}>
                 <div className="game-name">{game.rankingMatchU8}</div>
               <div className="game-info-header">
                   <div className="game-row">Klo {game.time}</div>
                   <div className="game-row">
                     {lohko === "U8_lohko_A" && "(Lehvosen pääty)"}
                     {lohko === "U8_lohko_B" && "(Kellopääty)"}
                     <span>
                       {(lohko === "U8_sijoitusottelut") &&
                         (game.id % 2 === 0 ? "(Kellopääty)" : "(Lehvosen Pääty)")}
                     </span>
                   </div>
                 </div>
                 <div className="game-row">
                   <table className="game-table">
                     <tbody>
                       <tr>
                         <td className="team-name">{game.team1}</td>
                         <td className="separator">-</td>
                         <td className="team-name">{game.team2}</td>
                       </tr>
                     </tbody>
                   </table>
                 </div>
               </div>
              ))}
            </div>
          ) : (
            /* Detailed table */
            <div>
              {sijoitusottelut[lohko].map(game => (
                <div key={game.id} className="game-info">
                  <div className="game-name">{game.rankingMatchU8}</div>
                  <div className="game-info-header">
                    <div className="game-row">Klo {game.time}</div>
                    <div className="game-row">
                      {game.id%2===0? '(Kellopääty)': '(Lehvosen pääty)'}
                    </div>
                  </div>
                  <div className="game-row">
                    {isAdmin && <button onClick={handleSave} className="save-button">Save</button>}
                  </div>
                  <table className="game-table">
                    <tbody>
                      <tr>
                        <td className="team-logo-cell">
                          <img
                            src={teams.teams_logos.find(t=>t.name===game.team1)?.logoUrl}
                            alt={game.team1}
                            className="team-logo"
                          />
                        </td>
                        <td className="game-result">
                          {isAdmin
                            ? <input
                                type="text"
                                value={game.result1}
                                onChange={e=>handleResultChange(lohko,game.id,'result1',e.target.value)}
                                className="game-result-input"
                              />
                            : <span className="game-result-text">{game.result1||'0'}</span>
                          }
                        </td>
                        <td className="separator">-</td>
                        <td className="game-result">
                          {isAdmin
                            ? <input
                                type="text"
                                value={game.result2}
                                onChange={e=>handleResultChange(lohko,game.id,'result2',e.target.value)}
                                className="game-result-input"
                              />
                            : <span className="game-result-text">{game.result2||'0'}</span>
                          }
                        </td>
                        <td className="team-logo-cell">
                          <img
                            src={teams.teams_logos.find(t=>t.name===game.team2)?.logoUrl}
                            alt={game.team2}
                            className="team-logo"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>{game.team1}</td><td colSpan="3"/><td>{game.team2}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ))}
            </div>
          )
        )}
    
        {/* === Sub-tab: Lohkotilanne === */}
        {selectedSubTab==='lohkotilanne' && lohko!=='U8_sijoitusottelut' && (
          <div className="ranking-table-container">
            <h2>Lohkotilanne | Lohko {lohko.slice(-1)}</h2>
            <table className="ranking-table">
            <thead>
              <tr>
              <th style={{width:'6px'}}>Sija</th>
                <th>Joukkue</th>
                <th>Ott</th>
                <th>V</th>
                <th>T</th>
                <th>H</th>
                <th>TM-HM</th>
  
                <th>Pst</th>
              </tr>
            </thead>
            <tbody>
                  {calculateTeamStats(lohko).map((teamStats,index) => (
                    <tr key={teamStats.name}>
                      <td style={{ width: '6px' }}> {index + 1}</td>
                      <td style = {{textAlign:'left'}}>
                      <img
                          style={{ width: '25px', height: '25px', marginRight: '8px', verticalAlign: 'middle' }} 
                          src={teams.teams_logos.find((team) => team.name === teamStats.name)?.logoUrl || "default-logo.png"}
                          alt={teamStats.name}
                        />
                        {teamStats.name}
                      </td>
                      <td>{teamStats.gamesPlayed}</td>
                      <td>{teamStats.win}</td>
                      <td>{teamStats.loss}</td>
                      <td>{teamStats.draw}</td>
                      <td>{teamStats.goalsFor}-{teamStats.goalsAgainst}</td>
                      <td>{teamStats.points}</td>
                    </tr>
                  ))}
                </tbody>
            </table>
          </div>
        )}
      </div>
    );
                };
export default SunnuntaiU8;
